<template>
  <div class="outer-container flex justify-center bg-white dark:bg-slate-800" :class="{ '-mr-1': !isSpecialRoute }">
    <div v-if="filteredPreviousIcons.length > 0"
      class="icons-scroll-container flex flex-col items-center pt-6 pb-6 p-0 bg-white dark:bg-slate-800 sm:gap-3 md:gap-4 lg:gap-5 xl:gap-6">
      <div v-for="(icon, index) in filteredPreviousIcons" :key="index" class="tooltip-wrapper relative group "
      >
        <woot-button class="custom-button messenger" @click="openConversation(icon)"
         v-tooltip="{
  content: icon.inbox?.name || localStorage.getItem(`inbox-name-${icon.conversationId}`) || 'Unnamed Inbox',
    placement: 'left',
  container: 'body',
  boundariesElement: 'viewport',
  popperOptions: {
    modifiers: {
      flip: { enabled: false },
    },
  },
  hideOnClick: true,
  offset:4,
}">
          <span v-if="icon.unreadCount > 0 && !isRailIconActive(icon)" class="unread-count">
            {{ icon.unreadCount }}
          </span>
          <img
            v-if="icon.image"
            :src="icon.image"
            :alt="icon.name"
            class="channel-logo"
            :class="[
              icon.class,
              { 'active-icon': isRailIconActive(icon) },
            ]"
          />
          <fluent-icon
            v-else
            :icon="icon.data"
            :viewBox="icon.viewBox"
            :size="'50'"
            :class="[
              icon.class,
              { 'active-icon': isRailIconActive(icon) },
            ]"
          />
        </woot-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InboxName from '../InboxName';
import { frontendURL, conversationUrl } from '../../../helper/URLHelper';
import { findSameContactInList } from '../../../helper/conversationContact';

export default {
  components: {
    InboxName,
  },
  props: {
    conversationId: {
      type: [String, Number],
      required: true,
    },
    // messages: {
    //   type: [Array],
    //   required: true,
    // },
  },
  data() {
    return {
      inboxId: "",
      icons: [
        {
          name: 'Whatsapp',
          data: 'whatsapp',
          viewBox: '-4 -4 35.676 35.676',
          class: 'whatsapp',
        },
        {
          name: 'Facebook',
          data: 'facebook',
          viewBox: '-4 -4 35.676 35.676',
          class: 'insta-icon',
        },
        {
          name: 'Telegram',
          data: 'telegram',
          viewBox: '-4 -4 35.676 35.676',
          class: 'insta-icon',
        },

        {
          name: 'Email',
          data: 'mail',
          viewBox: '-5.6 -5 35.676 35.676',
          class: 'email',
        },
        {
          name: 'Messenger',
          data: 'messenger',
          viewBox: '-2 -2 35.676 35.676',
          class: 'insta-icon',
        },
        {
          name: 'Instagram',
          data: 'instagram',
          viewBox: '-10 -10 53 53',
          class: 'insta-icon',
        },
        {
          name: 'Twitter',
          data: 'twitter',
          viewBox: '0 0 512 512',
          class: 'insta-icon',
        },
        {
          name: 'WebWidget',
          data: 'web',
          viewBox: '-7 -10 53 53',
          class: 'insta-icon',
        },
        {
          name: 'Api',
          data: 'api',
          viewBox: '-3 -4 30 30',
          class: 'insta-icon',
        },
        {
          name: 'TwilioSms',
          data: 'sms',
          viewBox: '30 12 40 75',
          class: 'insta-icon',
        },
        {
          name: 'Line',
          data: 'line',
          viewBox: '-3 -3 30 30',
          class: 'insta-icon',
        },
        {
          name: 'JioEva',
          data: 'jio',
          viewBox: '-7 -6 39 35',
          class: 'insta-icon',
        },
        {
          name: 'Smartflo',
          data: 'call',
          viewBox: '-4 -4 35.676 35.676',
          class: 'insta-icon',
        },
        {
          name: 'Indiamart',
          image: '/assets/images/dashboard/channels/indiamart.png',
          class: 'insta-icon',
        },
        {
          name: 'TwilioCall',
          data: 'twilio',
          viewBox: '-7 -4 45 35',
          class: 'twilio',
        },
      ],
      currentConversationId: null,
      currentUrl: '',
      lastChat: {},
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'getContactSidebarUiFlags',
      currentChat: 'getSelectedChat',
    }),
    chatMetadata() {
      return this.chat.meta;
    },
    contactId() {
      const chat = this.currentChat;
      if (!chat || !Object.keys(chat).length) return undefined;
      const fromRoot = chat.contact_id;
      const fromMeta = chat.meta?.sender?.id;
      if (fromRoot != null && fromRoot !== '') return Number(fromRoot);
      if (fromMeta != null && fromMeta !== '') return Number(fromMeta);
      const msgs = chat.messages || [];
      for (let i = msgs.length - 1; i >= 0; i -= 1) {
        const m = msgs[i];
        if (m.sender_type === 'Contact' && m.sender?.id != null) {
          return Number(m.sender.id);
        }
      }
      return undefined;
    },
    channelName() {
      return this.currentChat.meta?.channel?.split('::')[1];
    },
    filteredIcons() {
      return this.icons.filter(icon =>
        icon.name.toLowerCase().includes(this.channelName.toLowerCase())
      );
    },
    conversations() {
      if (!this.contactId) return [];
      return this.$store.getters.getConversationsForContact(this.contactId);
    },
    inbox() {
      return this.$store.getters['inboxes/getInbox'](this.inboxId);
    },
    currentId() {
      const url = this.currentUrl.split('/');
      return Number(url[url.length - 1]);
    },
    previousConversations() {
      return this.conversations.sort((a, b) => b.timestamp - a.timestamp);
    },
    filteredPreviousIcons() {
      if(this.isSpecialRoute)
      {
        this.currentConversationId=this.conversationId;
      }
      return this.previousConversations
        .map(conversation => {
          const channel = conversation.meta?.channel?.split('::')[1];
          if (!channel) return null;
          let iconName = channel;

          if (channel.toLowerCase() === 'facebookpage') {
            const type = conversation.additional_attributes?.type;
            iconName = type ? 'Instagram' : 'Messenger';
          }
          const icon = this.icons.find(
            icon => icon.name.toLowerCase() === iconName?.toLowerCase()
          );
          // Prefer the store inbox; otherwise build a fallback from the
          // conversation payload so agents who can view but don't collaborate on
          // this inbox still see the channel icon, label and tooltip.
          const storeInbox = this.$store.getters['inboxes/getInbox'](conversation.inbox_id);
          const inboxObj =
            storeInbox && storeInbox.id
              ? storeInbox
              : {
                  id: conversation.inbox_id,
                  name:
                    conversation.meta?.inbox_name ||
                    conversation.inbox?.name ||
                    channel,
                  channel_type:
                    conversation.meta?.channel || conversation.channel_type,
                  phone_number: conversation.phone_number,
                };
          if (icon && inboxObj) {
            localStorage.setItem(`inbox-name-${conversation.id}`, inboxObj.name || 'Unnamed Inbox');
            return {
              ...icon,
              conversationId: conversation.id,
              unreadCount: conversation.unread_count,
              inbox: inboxObj,
            };
          }

          return null;
        })
        .filter(Boolean); // Remove any null values, keeping duplicates
    },
    // displayedIcons() {
    //   // If filteredPreviousIcons has at least one icon, add "Concrete" to the end
    //   if (this.filteredPreviousIcons.length > 0 &&this.isSpecialRoute) {
    //     return [
    //       ...this.filteredPreviousIcons,
    //       {
    //         name: "Concrete",
    //         data: "concrete",
    //         viewBox: "0 0 41 41",
    //         class: "insta-icon",
    //       },
    //     ];
    //   }
    //   return this.filteredPreviousIcons;
    // },
    isSpecialRoute() {
      const { path, query } = this.$route;

      // Updated regex to match "/app/accounts/{id}/contacts/{contactId}"
      const specialRoutePattern = /^\/app\/accounts\/\d+\/contacts\/\d+$/;

      return specialRoutePattern.test(path) && !query.page; // Exclude routes with `page` query parameter
    },
  },
  watch: {
    $route(to) {
      this.currentUrl = to.path;
      const conversationId = Number(this.currentUrl.split('/').pop());
      this.currentConversationId = conversationId; // Update the active conversation ID
    },
    conversationId(newVal) {
      this.currentConversationId = newVal;
      const conversation = this.previousConversations.find(
        conv => conv.id === newVal
      );
      if (conversation) {
        this.inboxId = conversation.inbox_id;
        const channel = conversation.meta?.channel?.split('::')[1];
        this.currentChat.meta.channel = `channel::${channel}`;
      }
      this.fetchContactConversations();
    },
  },
  mounted() {
    this.fetchContactConversations();
    this.currentUrl = this.$route.path;
    bus.$on('emit-data', () => {
      this.fetchContactConversations();
    });
  },
  methods: {
    fetchContactConversations() {
      const id = this.contactId;
      if (id == null || Number.isNaN(Number(id))) return;
      this.$store.dispatch('fetchContactConversations', id);
    },
    isRailIconActive(icon) {
      const selected =
        this.currentConversationId || this.currentChat?.id || this.currentId;
      return Number(icon.conversationId) === Number(selected);
    },
    isConversationInVisibleList(conversationId) {
      const ids = this.$store.getters.getVisibleConversationIds || [];
      return ids.some(id => Number(id) === Number(conversationId));
    },
    routeConversationId() {
      const params = this.$route.params || {};
      const raw = params.conversation_id || params.conversationId;
      const id = Number(raw);
      return Number.isFinite(id) && id > 0 ? id : null;
    },
    visibleListConversations() {
      const ids = this.$store.getters.getVisibleConversationIds || [];
      return ids
        .map(id => this.$store.getters.getConversationById(id))
        .filter(Boolean);
    },
    isUsableAnchor(id, targetId) {
      return (
        id &&
        Number(id) !== Number(targetId) &&
        this.isConversationInVisibleList(id)
      );
    },
    anchorConversationId(targetId) {
      const detached = this.$store.getters.getDetachedListHighlight;
      if (this.isUsableAnchor(detached?.anchorConversationId, targetId)) {
        return Number(detached.anchorConversationId);
      }

      const currentId = Number(this.currentChat?.id);
      if (this.isUsableAnchor(currentId, targetId)) {
        return currentId;
      }

      const routeId = this.routeConversationId();
      if (this.isUsableAnchor(routeId, targetId)) {
        return routeId;
      }

      const target =
        this.$store.getters.getConversationById(targetId) ||
        this.previousConversations.find(
          conversation => Number(conversation.id) === Number(targetId)
        );
      const sameContact = findSameContactInList(
        this.visibleListConversations,
        target || this.currentChat,
        targetId
      );
      return sameContact ? sameContact.id : null;
    },
    isConstrainedListRoute() {
      const { name, path } = this.$route;
      const names = [
        'inbox_dashboard',
        'conversation_through_inbox',
        'label_conversations',
        'conversations_through_label',
        'folder_conversations',
        'conversations_through_folders',
      ];
      if (names.includes(name)) return true;
      return /\/(label|inbox|custom_view)(\/|$)/.test(path || '');
    },
    isAllConversationsRoute() {
      const { name, path } = this.$route;
      if (name === 'home' || name === 'inbox_conversation') return true;
      return /\/accounts\/\d+\/(dashboard|conversations\/\d+)\/?$/.test(
        path || ''
      );
    },
    async activateConversation(conversation, targetId) {
      let data =
        this.$store.getters.getConversationById(targetId) || conversation;
      if (!data) {
        await this.$store.dispatch('getConversation', targetId);
        data = this.$store.getters.getConversationById(targetId);
      }
      if (data && Number(this.currentChat?.id) !== targetId) {
        await this.$store.dispatch('setActiveChat', { data });
      }
    },
    async openInPlace(conversation, targetId, alternateHighlight) {
      await this.$store.dispatch('setDetachedListHighlight', {
        anchorConversationId: alternateHighlight
          ? this.anchorConversationId(targetId)
          : null,
        alternateHighlight,
        routePath: this.$route.fullPath,
      });
      await this.activateConversation(conversation, targetId);
    },
    async openWithUpdatedUrl(conversation, targetId, inList) {
      const path = this.conversationPathFor(targetId);
      if (!inList) {
        await this.$store.dispatch('setDetachedListHighlight', {
          anchorConversationId: this.anchorConversationId(targetId),
          alternateHighlight: true,
          routePath: path,
        });
        await this.activateConversation(conversation, targetId);
      } else {
        await this.$store.dispatch('clearDetachedListHighlight');
      }
      if (this.$route.path !== path) {
        this.$router.push({ path });
        return;
      }
      if (inList) {
        await this.activateConversation(conversation, targetId);
      }
    },
    conversationPathFor(conversationId) {
      const { name, params } = this.$route;
      const labelNames = ['label_conversations', 'conversations_through_label'];
      const inboxNames = ['inbox_dashboard', 'conversation_through_inbox'];
      const folderNames = [
        'folder_conversations',
        'conversations_through_folders',
      ];
      const teamNames = ['team_conversations', 'conversations_through_team'];
      let conversationType = '';
      if (
        name === 'conversation_mentions' ||
        name === 'conversation_through_mentions'
      ) {
        conversationType = 'mention';
      } else if (
        name === 'conversation_unattended' ||
        name === 'conversation_through_unattended'
      ) {
        conversationType = 'unattended';
      } else if (
        name === 'conversation_participating' ||
        name === 'conversation_through_participating'
      ) {
        conversationType = 'participating';
      }

      return frontendURL(
        conversationUrl({
          accountId: params.accountId,
          id: conversationId,
          activeInbox: inboxNames.includes(name) ? params.inbox_id : undefined,
          label: labelNames.includes(name) ? params.label : undefined,
          teamId: teamNames.includes(name) ? params.teamId : undefined,
          foldersId: folderNames.includes(name) ? params.id : undefined,
          conversationType,
        })
      );
    },
    async openConversation(selected) {
      const targetId = Number(selected.conversationId);
      this.currentConversationId = targetId;

      const conversation = this.previousConversations.find(
        conv => Number(conv.id) === targetId
      );
      if (conversation) {
        this.fetchContactConversations();
        const channel = conversation.meta?.channel?.split('::')[1];
        if (channel && this.currentChat?.meta) {
          this.currentChat.meta.channel = `channel::${channel}`;
        }
      }

      if (this.isSpecialRoute) {
        bus.$emit('open-conversation', conversation);
        return;
      }

      const inList = this.isConversationInVisibleList(targetId);

      if (this.isConstrainedListRoute()) {
        if (inList) {
          await this.openWithUpdatedUrl(conversation, targetId, true);
        } else {
          await this.openInPlace(conversation, targetId, true);
        }
        return;
      }

      if (this.isAllConversationsRoute() || inList) {
        await this.openWithUpdatedUrl(conversation, targetId, inList);
        return;
      }

      await this.openInPlace(conversation, targetId, true);
    },
  },
};
</script>


<style scoped>
.outer-container {
  width: 72px;
  height: 100%;
  padding: 1px;
  display: flex;
  justify-content: center;
  position: relative;
  flex: 0 0 72px;
  min-height: 0;
  /* margin: -10px; */
  /* background-color: white; */
  border: 1px solid #fbfbfb;
  margin-top: 0px;
  /* margin-right: -5px; */
  overflow: hidden;
}

.icons-scroll-container {
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-gutter: stable;
}

.custom-button {
  background-color: #fff !important;
  padding:0px;
}

.custom-button >>> svg {
  width: 24px;
  height: 24px;
  color: #5a524e;
  transition: color 0.3s ease;
}

.inner-container:hover .custom-button {
  background-color: white;
}

.instagram >>> span {
  width: auto;
}

.messenger >>> span {
  width: auto;
}

.web >>> span {
  width: auto;
}

.twitter >>> span {
  width: auto;
}

.insta-icon,
.email,
.whatsapp,
.twilio {
  width: 40px !important;
  height: 40px !important;
}

.channel-logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
  padding: 4px;
  display: block;
}

.insta-icon:hover {
  color: blue;
  /* Alternatively, change the text or icon color if applicable */
}

.whatsapp:hover {
  color: #44ce4b;
}

.facebook:hover {
  color: blue;
}

.email:hover {
  color: red;
}
.twilio:hover {
  color: red;
}

.active-icon {
  color: #40518a !important;
  background-color: deepskyblue;
  border-radius: 5px;
  /* Change this to the desired active color */
}

.unread-count {
  position: absolute;
  right: 15px;
  background-color: #40518a;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 12px;
}
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}
.tooltip-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}


</style>